import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { initialState } from '../../../../data/entitlement/entitlements/warrantyInfo/initialState.warrantyInfo.data';
import {
  rqsModal as rqsModalAPI,
  fetchSerialNoHistory as fetchSerialNoHistoryAPI,
  warrantyPartNoChange as warrantyPartNoChangeAPI,
  serialNoInfo as serialNoInfoAPI,
  searchSerialNo as searchSerialNoAPI,
  swappingEsr as swappingEsrAPI,
  searchWarranties as searchWarrantiesAPI,
} from '../../../../apis/entitlementWarrantyInfo.js';
import { ACTIONS_WARRANTY_INFO_TAB } from '../../../../constants/actionCreator';
import { GRID_ROWS_PER_PAGE, SLICE_NAME } from '../../../../constants/index.js';

export const rqsModal = createAsyncThunk(
  ACTIONS_WARRANTY_INFO_TAB.RQSMODAL,
  async (body, { rejectWithValue }) => {
    try {
      const response = await rqsModalAPI(body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchSerialNoHistory = createAsyncThunk(
  ACTIONS_WARRANTY_INFO_TAB.SEARCHSERIALNO,
  async (body, { rejectWithValue }) => {
    try {
      const response = await fetchSerialNoHistoryAPI(body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const warrantyPartNoChange = createAsyncThunk(
  ACTIONS_WARRANTY_INFO_TAB.WPNSWAP,
  async (body, { rejectWithValue }) => {
    try {
      const response = await warrantyPartNoChangeAPI(body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const serialNoInfo = createAsyncThunk(
  ACTIONS_WARRANTY_INFO_TAB.GETSRINFO,
  async (body, { rejectWithValue }) => {
    try {
      const response = await serialNoInfoAPI(body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const searchSerialNo = createAsyncThunk(
  ACTIONS_WARRANTY_INFO_TAB.SEARCHSR,
  async (body, { rejectWithValue }) => {
    try {
      const response = await searchSerialNoAPI(body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const swappingEsr = createAsyncThunk(
  ACTIONS_WARRANTY_INFO_TAB.SWAPESR,
  async (body, { rejectWithValue }) => {
    try {
      const response = await swappingEsrAPI(body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const searchWarranties = createAsyncThunk(
  ACTIONS_WARRANTY_INFO_TAB.searchWarranty,
  async (body, { rejectWithValue }) => {
    try {
      const response = await searchWarrantiesAPI(body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const WarrantyInfoSlice = createSlice({
  name: SLICE_NAME.warrantyInfo,
  initialState,
  reducers: {
    setRqsId: (state, action) => {
      state.rqsId = action?.payload;
    },
    openWarrantyModal: (state) => {
      state.isOpenWarranty = true;
    },
    closeWarrantyModal: (state) => {
      state.isOpenWarranty = false;
    },
    openSwapModal: (state) => {
      state.isSwap = true;
    },
    closeSwapModal: (state) => {
      state.isSwap = false;
    },
    setserialNo: (state, action) => {
      state.serialNo = action?.payload;
    },
    resetSerialNo: (state) => {
      state.serialNo = initialState.serialNo;
    },
    resetWarrantyGridData: (state) => {
      state.rqsCount = initialState.rqsCount;
      state.rqsModalData = initialState.rqsModalData;      
      state.loadingRqs = initialState.loadingRqs;
    },
    eidSet: (state, action) => {
      state.searchEid = action?.payload;
    },
    srSet: (state, action) => {
      state.searchSr = action?.payload;
    },
    wpnSet: (state, action) => {
      state.searchWpn = action?.payload;
    },
    swapAlertOpen: (state) => {
      state.swapAlert = true;
    },
    swapAlertClose: (state) => {
      state.swapAlert = false;
    },
    resetSwap: (state) => {
      state.swapApiCall = false;
    },
    swapReqSet: (state, action) => {
      const { currentEntitlementId, swapEntitlementId, userId } =
        action?.payload ? action?.payload : null;
      state.swapReqData = {
        ...state.swapReqData,
        currentEntitlementId,
        swapEntitlementId,
        userId,
      };
    },
    wIdSet: (state, action) => {
      state.wid = action?.payload;
    },
    resetSrFilter: (state) => {
      state.searchEid = '';
      state.searchSr = '';
      state.searchWpn = '';
    },
    resetSearchSwapGrid: (state) => {
      state.srNoFilter = initialState.srNoFilter;
    },
    tempRqsIdSet: (state, action) => {
      state.tempRqsId = action?.payload;
    },
    resetSnSwapGridData: (state) => {
      state.totalRecords = initialState.totalRecords;
      state.srNoFilter = initialState.srNoFilter;
      state.searchLoad = initialState.searchLoad;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(rqsModal.pending, (state) => {
        state.loadingRqs = true;
        state.rqsModalData = [];
      })
      .addCase(rqsModal.fulfilled, (state, action) => {
        state.loadingRqs = false;
        state.rqsModalData = action?.payload?.warranties
          ? action?.payload?.warranties
          : [];
        state.rqsCount = action?.payload?.totalRecords
          ? action?.payload?.totalRecords
          : GRID_ROWS_PER_PAGE.initialVal;
      })
      .addCase(rqsModal.rejected, (state) => {
        state.loadingRqs = false;
        state.rqsModalData = [];
      })

      .addCase(fetchSerialNoHistory.pending, (state) => {
        state.loading = true;
        state.serialNoHistoryResult = [];
      })
      .addCase(fetchSerialNoHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.serialNoHistoryResult = action?.payload ? action?.payload : [];
      })
      .addCase(fetchSerialNoHistory.rejected, (state) => {
        state.loading = false;
        state.serialNoHistoryResult = [];
      })

      .addCase(warrantyPartNoChange.pending, (state) => {
        state.loading = true;
        state.partChange = [];
      })
      .addCase(warrantyPartNoChange.fulfilled, (state, action) => {
        state.loading = false;
        state.partChange = action?.payload ? action?.payload : [];
      })
      .addCase(warrantyPartNoChange.rejected, (state) => {
        state.loading = false;
        state.partChange = [];
      })

      .addCase(serialNoInfo.pending, (state) => {
        state.loading = true;
        state.partChange = [];
      })
      .addCase(serialNoInfo.fulfilled, (state, action) => {
        state.loading = false;
        state.serialInfo = action?.payload;
      })
      .addCase(serialNoInfo.rejected, (state) => {
        state.loading = false;
        state.partChange = [];
      })

      .addCase(searchSerialNo.pending, (state) => {
        state.searchLoad = true;
        state.srNoFilter = [];
      })
      .addCase(searchSerialNo.fulfilled, (state, action) => {
        state.searchLoad = false;
        state.srNoFilter = action?.payload?.serialNos
          ? action?.payload?.serialNos
          : [];
        state.totalRecords = action?.payload?.totalRecords
          ? action?.payload?.totalRecords
          : 0;
      })
      .addCase(searchSerialNo.rejected, (state) => {
        state.searchLoad = false;
        state.srNoFilter = [];
      })

      .addCase(swappingEsr.pending, (state) => {
        state.loadingEsr = true;
        state.swapESr = [];
      })
      .addCase(swappingEsr.fulfilled, (state, action) => {
        state.loadingEsr = false;
        state.swapESr = action?.payload?.serialNos
          ? action?.payload?.serialNos
          : [];
        state.totalRecords = action?.payload?.totalRecords
          ? action?.payload?.totalRecords
          : 0;
      })
      .addCase(swappingEsr.rejected, (state) => {
        state.loadingEsr = false;
        state.swapESr = [];
      })

      .addCase(searchWarranties.pending, (state) => {
        state.loadingRqs = true;
        state.rqsModalData = [];
      })
      .addCase(searchWarranties.fulfilled, (state, action) => {
        state.loadingRqs = false;
        state.rqsModalData = action?.payload?.warranties
          ? action?.payload?.warranties
          : [];
        state.rqsCount = action?.payload?.totalRecords
          ? action?.payload?.totalRecords
          : 0;
      })
      .addCase(searchWarranties.rejected, (state) => {
        state.loadingRqs = false;
        state.rqsModalData = [];
      });
  },
});

export const {
  setRqsId,
  setSerialNoHistoryResult,
  openWarrantyModal,
  closeWarrantyModal,
  setRqsModalData,
  setserialNo,
  resetSerialNo,
  openSwapModal,
  closeSwapModal,
  eidSet,
  srSet,
  wpnSet,
  swapAlertOpen,
  swapAlertClose,
  resetSwap,
  swapReqSet,
  wIdSet,
  resetSrFilter,
  resetSearchSwapGrid,
  tempRqsIdSet,
  resetSnSwapGridData,
  resetWarrantyGridData,
} = WarrantyInfoSlice.actions;

export default WarrantyInfoSlice.reducer;
